import React, { useState, useContext, useEffect } from "react";
import Head from "../Head/Head";
import Squares from "../Squares/Squares";
import Text from "../Text/Text";
import "./StepOne.scss";
import plus from "../../assets/plus.svg";
import { SquareContext } from "../../SquareContext";

function StepOne(props) {
  const {
    listItems,
    btnColor,
    cart,
    listShape,
    dimShape,
    stepDesc,
  } = useContext(SquareContext);

  function handleNextOne() {
    if (cart.length !== 0) {
      props.next();
    }
  }

  return (
    <div className="stepOne">
      
      {stepDesc[0] && (
        <div>
          {/* <Head
            title={"STEP 1"}
            // description={stepDesc[0] !== undefined && stepDesc[0].title}
            dangerouslySetInnerHTML={{ __html: stepDesc[0].title }}
          /> */}
          <div className="head">
            <p className="head-red">STEP 1</p>
            <p className="head-line">I</p>
            <p  dangerouslySetInnerHTML={{ __html: stepDesc[0].title }}></p>
          </div>
        </div>
      )}

      <div className="stone">
        <Squares />
        {stepDesc[0] !== undefined && (
          <div
            className="text-middle2"
            dangerouslySetInnerHTML={{ __html: stepDesc[0].description }}
          >

        
            {/* <Text
            // desc={stepDesc[0] !== undefined && { __html: stepDesc[0].description }}
            // desc={{ __html: stepDesc[0].description }}
            /> */}
          </div>
        )}

        <div className="buttons btn-middle ">
          <button className="btn-prev hidden">BACK STEP</button>
          <button
            className="btn-next no-marg"
            onClick={handleNextOne}
            style={{ background: btnColor }}
          >
            NEXT STEP
          </button>
       
        </div>
      </div>
      <div className="test-container">
        <div className="test-form-sq">{listItems}</div>
      </div>
    </div>
  );
}

export default StepOne;
